import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import "channels"
import "controllers"

import "bootstrap"

Rails.start()
